import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { useSetRecoilState } from "recoil";
import { bugReportModalState } from ".";

export default function RenderAccess({
    accessMap
}: {
    accessMap: Object;
}) {

    const history = useHistory();
    const [collapsedTabs, setCollapsedTabs] = useState<Record<string, boolean>>({});
    const setBugReportModal = useSetRecoilState(bugReportModalState);
    
    const toggleCollapse = (tabId: string) => {
        setCollapsedTabs(prev => ({ ...prev, [tabId]: !prev[tabId] }));
    };

    const navigateTo = (route: string) => {
        setBugReportModal(false);
        history.push(route);
    }

    return (
        <div className={'mt-2'}>
            <h5>Select your page:</h5>
            {
                Object.keys(accessMap).map(tabId => accessMap[tabId].label && (
                    <div className={'mb-5'} key={tabId}>
                        <div
                            onClick={() => toggleCollapse(tabId)}
                            style={{
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '10px',
                                padding: '12px 16px',
                                backgroundColor: '#f3f4f6',
                                borderRadius: '8px',
                                transition: 'background-color 0.2s',
                            }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#e5e7eb'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                        >
                            <h1 className='mb-0 pb-0'>{accessMap[tabId].label}</h1>
                            <span style={{
                                transform: collapsedTabs[tabId] ? 'rotate(-90deg)' : 'rotate(0deg)',
                                transition: 'transform 0.2s',
                                fontSize: '1.2rem',
                            }}>
                                ▼
                            </span>
                        </div>
                        {
                            collapsedTabs[tabId] && accessMap[tabId].subs && Object.keys(accessMap[tabId].subs).map(subId => (
                                <div key={subId} style={{ padding: '4px 16px' }}>
                                    <h3 style={{ margin: '8px 0' }}>
                                        {
                                            (accessMap[tabId].subs[subId].subs === undefined || Object.keys(accessMap[tabId].subs[subId].subs).length === 0) ?
                                                <div
                                                    onClick={() => navigateTo(accessMap[tabId].subs[subId].to)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '8px 12px',
                                                        borderRadius: '6px',
                                                        backgroundColor: 'transparent',
                                                        transition: 'background-color 0.2s',
                                                    }}
                                                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                                                >
                                                    {accessMap[tabId].subs[subId].label}
                                                </div> :
                                                <div style={{
                                                    fontStyle: 'italic',
                                                    color: '#6b7280',
                                                    borderLeft: '3px solid #9ca3af',
                                                    paddingLeft: '10px',
                                                    marginTop: '12px',
                                                    fontSize: '0.85em',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.05em',
                                                }}>
                                                    {accessMap[tabId].subs[subId].label}
                                                </div>
                                        }
                                    </h3>
                                    {
                                        accessMap[tabId].subs[subId].subs && Object.keys(accessMap[tabId].subs[subId].subs).map(finalSubId => (
                                            <h5 className={'pl-4'} key={finalSubId} style={{ margin: '4px 0' }}>
                                                <div
                                                    onClick={() => navigateTo(accessMap[tabId].subs[subId].subs[finalSubId].to)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '8px 12px 8px 24px',
                                                        borderRadius: '6px',
                                                        backgroundColor: 'transparent',
                                                        transition: 'background-color 0.2s',
                                                    }}
                                                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                                                >
                                                    {accessMap[tabId].subs[subId].subs[finalSubId].label}
                                                </div>
                                            </h5>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                ))
            }
        </div>
    );
}